import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ParentButtonComponent } from '../../../../shared/components/ui/parent-button/parent-button.component';
import { IdentityVerificationTier } from '../../models/identity-verification.model';
import { ParentIdentityService } from '../../services/parent-identity.service';

@Component({
  selector: 'app-parent-identity-section',
  standalone: true,
  imports: [CommonModule, TranslatePipe, ParentButtonComponent],
  templateUrl: './parent-identity-section.component.html',
  styleUrl: './parent-identity-section.component.scss',
})
export class ParentIdentitySectionComponent {
  #identity = inject(ParentIdentityService);
  #router = inject(Router);

  readonly layerEnabled = computed(() => this.#identity.layerEnabled());
  readonly status = computed(() => this.#identity.status());
  readonly isVerified = computed(() => this.#identity.isDocumentVerified());
  readonly isFullyVerified = computed(() => this.#identity.isFullyVerified());
  readonly canExpandFamily = computed(() => this.#identity.canExpandFamily());
  readonly inGracePeriod = computed(() => this.#identity.inGracePeriod());
  readonly graceDaysRemaining = computed(() => this.#identity.graceDaysRemaining());
  readonly shouldPromptVerification = computed(() =>
    this.#identity.shouldPromptVerification(),
  );

  readonly tierLabelKey = computed(() => {
    const tier = this.status()?.tier ?? IdentityVerificationTier.UNVERIFIED;
    const map: Record<string, string> = {
      [IdentityVerificationTier.UNVERIFIED]: 'app.identity.profile.tier.unverified',
      [IdentityVerificationTier.KYC_PENDING]: 'app.identity.profile.tier.kycPending',
      [IdentityVerificationTier.KYC_FAILED]: 'app.identity.profile.tier.kycFailed',
      [IdentityVerificationTier.KYC_MANUAL_REVIEW]: 'app.identity.profile.tier.kycManualReview',
      [IdentityVerificationTier.DOCUMENT_VERIFIED]: 'app.identity.profile.tier.documentVerified',
      [IdentityVerificationTier.GUARDIAN_ATTESTED]: 'app.identity.profile.tier.guardianAttested',
      [IdentityVerificationTier.FULLY_VERIFIED]: 'app.identity.profile.tier.fullyVerified',
    };
    return map[tier] ?? map[IdentityVerificationTier.UNVERIFIED];
  });

  startVerification(): void {
    void this.#router.navigate(['/identity/verify']);
  }
}
